<template lang="pug">
OrderActionModal(:show="show" max-width="min(100vw - 2rem, 40rem)" @close="onClose")
  template(slot="header")
    .delivery-tracking-modal__title Rastreo · {{ tracking }}

  .delivery-tracking-modal
    .delivery-tracking-modal__empty(v-if="error") {{ error }}

    .delivery-tracking-modal__empty(v-else-if="!events.length")
      | No hay movimientos registrados para esta guía.

    .delivery-tracking-modal__list(v-else)
      .delivery-tracking-modal__entry(v-for="(event, index) in events" :key="`${event.code || ''}-${event.date || ''}-${index}`")
        .delivery-tracking-modal__entry-head
          span.delivery-tracking-modal__description {{ event.description || '—' }}
          span.delivery-tracking-modal__date {{ formatEventDate(event) }}
        .delivery-tracking-modal__code(v-if="event.code") Código {{ event.code }}
</template>

<script>
import OrderActionModal from '@/components/pages/order/refund/OrderActionModal.vue'

export default {
  name: 'DeliveryTrackingModal',

  components: { OrderActionModal },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    tracking: {
      type: String,
      default: ''
    },
    events: {
      type: Array,
      default: () => []
    },
    error: {
      type: String,
      default: ''
    }
  },

  methods: {
    onClose () {
      this.$emit('close')
    },

    formatEventDate (event) {
      const parts = [event.date, event.hour].filter(Boolean)
      return parts.length ? parts.join(' · ') : '—'
    }
  }
}
</script>

<style lang="stylus" scoped>
.delivery-tracking-modal
  padding 0 1.5rem 1.5rem
  overflow-y auto
  max-height calc(100vh - 8rem)

.delivery-tracking-modal__title
  font-weight 600
  font-size 1.1rem

.delivery-tracking-modal__empty
  padding 1rem 0
  opacity .7
  font-size .95rem
  word-break break-word

.delivery-tracking-modal__entry
  padding .75rem 0
  border-bottom 1px solid rgba(0, 0, 0, .08)

  &:last-child
    border-bottom none

.delivery-tracking-modal__entry-head
  display flex
  flex-wrap wrap
  gap .35rem 1rem
  align-items baseline
  font-size .95rem

.delivery-tracking-modal__description
  font-weight 600
  text-transform capitalize

.delivery-tracking-modal__date
  margin-left auto
  font-size .85rem
  opacity .7
  white-space nowrap

.delivery-tracking-modal__code
  margin-top .35rem
  font-size .85rem
  opacity .65
</style>



// WEBPACK FOOTER //
// src/components/elements/delivery/DeliveryTrackingModal.vue